const slugify = (string, {
  separator = '-',
  convertCamelCase = false
} = {}) => {
  let output;

  if (convertCamelCase) {
    output = string.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-');
  }

  output = string.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, separator);
  return output;
};

export default slugify;